import { fetchPlan } from "shared/itemLists/redux/itemListsSlice";

const reloadPlanMiddleware = (store) => (next) => (action) => {
  const listeningTo = {
    "itemLists/updateItem.commit": true,
    "itemLists/moveItem.commit": true,
    "itemLists/deleteItem.commit": true,
    "waitForId/PATCH_WITH_SERVER_ID_COMMIT": true,
  };
  if (listeningTo[action.type]) {
    if (store.getState().itemLists.needsReload) {
      store.dispatch(fetchPlan());
    }
  }
  next(action);
};

export default reloadPlanMiddleware;
